import React from "react";
import { TrialProgressModal, EntitledModal } from ".";
import { getStorageItem, User } from "../../utilities";
import { withRouter } from "react-router";
import moment from "moment";


const Status: React.FunctionComponent<any> = ({ location: { pathname } }) => {
  const subType = getStorageItem("st", false, false, true);
  const query = new URLSearchParams(window.location.search);
  const token = query.get('token');
  
  const previousReminder = getStorageItem("smr", false, false, true);
  const reminded = previousReminder !== null && moment(previousReminder).isSame(moment(), "day");
  const pathIgnored = [
    "/authentication/upgrade/web/callback",
    "/settings"
  ].includes(pathname);

  return (
    (pathIgnored || token) ?
      null :
      <React.Fragment>
        { !reminded && User.provider() === "TMNET" && <TrialProgressModal /> }
        { subType &&  <EntitledModal type={subType} /> }
      </React.Fragment>
  );
};

export default withRouter(Status);
